import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="banner"
export default class extends Controller {
  static values = { type: String, url: String }

  dismiss() {
    this.element.remove()

    // Post /banner/dismiss
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ banner_type: this.typeValue }),
    })
  }
}
